import React from "react";
import { View } from "@react-pdf/renderer";
import { withNamespaces } from "react-i18next";

import DateUtils from "src/services/utils/DateUtils";

import styles from "../../styles";
import {
    buildDueDiligenceRecords,
    buildProductDetailRecords,
    buildProductSummaryRecords,
    DUE_DILIGENCE_COLUMNS,
    PRODUCT_DETAIL_CODES_DDS_COLUMNS,
    PRODUCT_DETAIL_IDENTITY_TRADE_COLUMNS,
    PRODUCT_SUMMARY_COLUMNS,
} from "../../helpers/productExport";
import { EntityRecordsTable, SectionTitle, SubSectionTitle } from "../../shared";

const ProductsSection = ({ t, supplierData = {}, meta }) => {
    const dateUtils = new DateUtils();
    const products = Array.isArray(supplierData?.products) ? supplierData.products : [];
    const supplierCountry = supplierData?.supplierDetail?.country;
    const child = meta?.child || {};

    const productSummaryRecords = buildProductSummaryRecords(products);
    const productDetailRecords = buildProductDetailRecords(products, {
        dateUtils,
        t,
        supplierCountry,
    });
    const dueDiligenceRecords = buildDueDiligenceRecords(products, {
        t,
        supplierCountry,
    });

    return (
        <View style={styles.wordSectionContent}>
            <EntityRecordsTable
                leading={(
                    <SectionTitle
                        title={meta?.title || "Products"}
                        number={meta?.number}
                        anchorId={meta?.anchorId}
                    />
                )}
                columns={PRODUCT_SUMMARY_COLUMNS}
                records={productSummaryRecords}
            />

            <EntityRecordsTable
                leading={(
                    <SubSectionTitle
                        title={child["products-detail"]?.title || "Products Detail"}
                        number={child["products-detail"]?.number}
                        anchorId={child["products-detail"]?.anchorId}
                    />
                )}
                columns={PRODUCT_DETAIL_IDENTITY_TRADE_COLUMNS}
                records={productDetailRecords}
            />
            <EntityRecordsTable
                columns={PRODUCT_DETAIL_CODES_DDS_COLUMNS}
                records={productDetailRecords}
            />

            <EntityRecordsTable
                leading={(
                    <SubSectionTitle
                        title={child["deforestation-due-diligence"]?.title || "Deforestation Due Diligence"}
                        number={child["deforestation-due-diligence"]?.number}
                        anchorId={child["deforestation-due-diligence"]?.anchorId}
                    />
                )}
                columns={DUE_DILIGENCE_COLUMNS}
                records={dueDiligenceRecords}
            />
        </View>
    );
};

export default withNamespaces()(ProductsSection);
